import {
  Code2,
  Compass,
  FileText,
  SpellCheck,
  TrendingUp,
  Users,
} from 'lucide-react'
import { NotionMark } from '@loop3/ui'
import { SOLUTIONS_REPOSITORY_URL } from '@loop3/universe'
import type { LinkItem } from '@/lib/tools'

/** Notion knowledge base (which this hub will eventually absorb), company wikis, and VC reference material. */
export const KNOWLEDGE_BASE: readonly LinkItem[] = [
  {
    id: 'kb-wiki',
    title: 'Wiki',
    description: 'The L3 Knowledge Base wiki in Notion.',
    icon: NotionMark,
    href: 'https://www.notion.so/dcc87505ce088336b1d0012cbd88010f',
  },
  {
    id: 'solutions-repository',
    title: 'L3 Solutions Repository',
    description:
      'Solutions we have built, catalogued for reuse across clients.',
    icon: NotionMark,
    href: SOLUTIONS_REPOSITORY_URL,
  },
  {
    id: 'sops',
    title: "SoP's",
    description:
      'Standard operating procedures: project setup, new clients, and upsells.',
    icon: NotionMark,
    href: 'https://www.notion.so/c1262a14f0194b849a7201960f04e626',
  },
  {
    id: 'tool-stack',
    title: 'Industry Tools Stack',
    description: 'Apps and services we use daily across client projects.',
    icon: NotionMark,
    href: 'https://www.notion.so/2ca87505ce08800a9b2ae6103e48ab99?v=2ca87505ce088034a087000c2ac00809',
  },
  {
    id: 'people-wiki',
    title: 'People Wiki',
    description: 'Team directory, HR policies, and onboarding resources.',
    icon: Users,
    href: 'https://www.notion.so/Human-Resources-Wiki-cef65c978b8840e6945b147619fac15d',
  },
  {
    id: 'engineering-wiki',
    title: 'Engineering Wiki',
    description:
      'Technical docs, architecture decisions, and engineering standards.',
    icon: Code2,
    href: 'https://www.notion.so/3f33278f43a14bda822ed8ec181ee586?v=255f84f674b94367964d1a275e72815e',
  },
  {
    id: 'level-me-up',
    title: 'Level-Me-Up',
    description:
      'Career growth framework — the Product Engineer ladder, 1:1 cadence, and annual bonus structure.',
    icon: TrendingUp,
    href: 'https://www.notion.so/Level-Me-Up-2bf87505ce088045894dfdd7179afe13',
  },
  {
    id: 'vc-resources',
    title: 'Resources',
    description:
      'Curated reading, industry references, and operational playbooks for VC work.',
    icon: FileText,
    href: 'https://www.notion.so/Resources-2f787505ce08806da2a1f0b7e88136c5',
  },
  {
    id: 'glossary',
    title: 'Glossary',
    description:
      'Definitions for terms that come up across fund docs, diligence, and portfolio conversations.',
    icon: SpellCheck,
    href: 'https://www.notion.so/Glossary-14d87505ce08804ea02fc27907836c28',
  },
  {
    id: 'building-for-vc',
    title: 'Building For VC',
    description:
      'External community and curated resources for teams building software for VC firms.',
    icon: Compass,
    href: 'https://buildingfor.vc/',
  },
]
